<template>
  <v-badge
    overlap
    :color="disabled ? 'transparent' : 'white'"
    class="smallButtonBadge"
    bottom
    offset-x="18"
    offset-y="18"
  >
    <template v-slot:badge>
      <v-btn
        x-small
        icon
        rounded
        slot="badge"
        @click="triggerFileSelection"
        v-if="!disabled"
      >
        <v-icon small>camera_alt</v-icon>
      </v-btn>
      <input
        class="d-none"
        type="file"
        id="file"
        ref="file"
        v-on:change="handleFileUpload"
      />
    </template>
    <v-progress-circular
      indeterminate
      color="primary"
      size="80"
      v-if="saving"
    ></v-progress-circular>
    <template v-else>
      <slot></slot>
    </template>
  </v-badge>
</template>

<script>
export default {
  name: "ImageEditBadge",
  props: {
    saveAction: {
      type: String,
      required: true
    },
    disabled: { type: Boolean, default: false },
    id: { type: [String, Number] }
  },
  data: () => ({
    saving: false
  }),
  methods: {
    handleFileUpload() {
      if (this.$refs.file.files) {
        this.saving = true;
        this.$store
          .dispatch(this.saveAction, {
            file: this.$refs.file.files[0],
            id: this.id
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while uploading an image."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    triggerFileSelection() {
      this.$refs.file.click();
    }
  }
};
</script>
